import React from 'react';
import { LandingPageAction } from '../../interfaces/LandingPageAction';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@chakra-ui/react';
import AuthModal, { AuthModalScreen } from '../Auth/Modal';
import BookDemoForm from './BookDemoForm';
import { useGetRequestCallback } from '../../hooks/V2/useRequestCallback';
import { useUser } from '../../hooks/V2/useUser';

/**
 * Landing page actions like Sign In, Book a Demo, etc.
 */

function LandingPageActionComponent({ buttonProps, action, disabled, text, href, variant, newTab }: LandingPageAction) {
	const navigate = useNavigate();
	const { data: user } = useUser();
	const [showModal, setShowModal] = React.useState(false);
	const { data: getCallbacksData, isLoading: getCallbacksLoading } = useGetRequestCallback('prepleaf_nav');

	const handleClick = () => {
		setShowModal(true);
	};
	return (
		<>
			{action === 'link' ? (
				href && (
					<Link to={href} className={`btn btn-primary ${disabled ? 'disabled' : ''}`} target={newTab ? '_blank' : '_self'}>
						<Button {...buttonProps} variant={variant}>
							{text}
						</Button>
					</Link>
				)
			) : (
				<Button
					{...buttonProps}
					onClick={e => {
						e.preventDefault();
						if (user) {
							handleClick();
						} else {
							navigate('/sign-in');
						}
					}}
					isDisabled={
						getCallbacksLoading || (getCallbacksData && typeof getCallbacksData === 'object' && !Array.isArray(getCallbacksData)) ? true : false
					}
					variant={variant}
				>
					{text}
				</Button>
			)}
			{['auth-sign-in', 'auth-sign-up'].includes(action) ? (
				<AuthModal
					defaultScreen={action === 'auth-sign-in' ? AuthModalScreen.LOGIN : AuthModalScreen.SIGNUP}
					isOpen={showModal}
					onClose={() => setShowModal(false)}
				/>
			) : null}
			{action === 'book-slot' ? <BookDemoForm isOpen={showModal} onClose={() => setShowModal(false)} title="Book a session now" /> : null}
		</>
	);
}

export default LandingPageActionComponent;
